module.exports = __webpack_public_path__ + "img/arrow-tip-up.e18cc64f.svg";